// test867
(867 && 0);
